import { IconPad } from '../IconPad';
import { FormattedNumber } from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';

export const SimpleFeature = ({ slug, trimLevel, unit, fieldType }) => (
  <IconPad>
    {fieldType === 'float' || fieldType === 'int' ? (
      <FormattedNumber value={trimLevel[slug]} />
    ) : (trimLevel[slug])}{unit && <span>{unit}</span>}
  </IconPad>
);
export default SimpleFeature;
SimpleFeature.propTypes={
  slug:PropTypes.string.isRequired,
  trimLevel:PropTypes.shape({}).isRequired,
  unit:PropTypes.string,
  fieldType:PropTypes.string.isRequired
};
